<template>
  <v-dialog max-width="600px" v-model="dialogModel">
    <v-card>
      <v-card-title class="headline">
        <span v-if="isEdit">{{ $t("message.editAccount") }}</span>
        <span v-else>
          {{ $t("message.accountCreation") }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-form ref="accountForm" v-model="accountForm.valid">
          <v-container grid-list-md pt-0>
            <v-layout row wrap>
              <v-flex md12 xs12>
                <v-text-field
                  :error-messages="errors.collect('bank_name')"
                  data-vv-name="bank_name"
                  :label="$t('message.paymentMethod')"
                  prepend-icon="mdi-bank"
                  required
                  type="text"
                  v-model="accountForm.bank_name"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-select
                  :error-messages="errors.collect('type')"
                  data-vv-name="type"
                  :items="accountType"
                  :label="$t('message.currency')"
                  prepend-icon="mdi-cash-multiple"
                  required
                  v-model="accountForm.type"
                  v-validate="'required'"
                ></v-select>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  :error-messages="errors.collect('account_number')"
                  data-vv-name="account_number"
                  :label="$t('message.accountNumber')"
                  prepend-icon="mdi-account-card-details"
                  required
                  type="text"
                  v-model="accountForm.account_number"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :error-messages="errors.collect('account_type')"
                  data-vv-name="account_type"
                  :label="$t('message.accountType')"
                  prepend-icon="zmdi-accounts-list"
                  required
                  type="text"
                  v-model="accountForm.account_type"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :error-messages="errors.collect('owner_full_name')"
                  data-vv-name="owner_full_name"
                  :label="$t('message.ownerName')"
                  prepend-icon="mdi-account"
                  required
                  type="text"
                  v-model="accountForm.owner_full_name"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-select
                  :error-messages="errors.collect('owner_identification_type')"
                  data-vv-name="owner_identification_type"
                  :items="documentType"
                  :label="$t('message.documentType')"
                  prepend-icon="mdi-file-document"
                  required
                  v-model="accountForm.owner_identification_type"
                  v-validate="'required'"
                ></v-select>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  :error-messages="errors.collect('owner_identification')"
                  data-vv-name="owner_identification"
                  :label="$t('message.ownerDocument')"
                  prepend-icon="mdi-file-document-box"
                  required
                  type="text"
                  v-model="accountForm.owner_identification"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  :label="$t('message.specialAcount')"
                  color="primary"
                  @change="setStrict"
                  :input-value="accountForm.strict"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline @click="onClose" color="error" small>{{
          $t("message.close")
        }}</v-btn>
        <v-btn outline @click="onSave" color="primary" small>{{
          $t("message.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { accountType, documentType } from "../../../constants/constants";
import { CREATE_ACCOUNT } from "../../../store/modules/accounts/actionTypes";
const initBank = {
  account_number: null,
  account_type: null,
  bank_name: null,
  owner_full_name: null,
  owner_identification: null,
  owner_identification_type: null,
  valid: false,
  strict: false,
  type: 0,
};

export default {
  props: {
    dialog: {
      required: false,
      default: false,
    },
    isEdit: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      accountForm: initBank,
      accountType,
      documentType,
      dialogModel: this.dialog,
    };
  },
  methods: {
    ...mapActions([CREATE_ACCOUNT]),
    resetForm() {
      //this.accountForm = initBank;
      this.$validator.reset();
      this.$refs.accountForm.reset();
    },
    onClose() {
      this.$emit("update:dialog", false);
      this.resetForm();
    },
    onSave() {
      if(this.isEdit) {
        this.$store.dispatch('updateAccount', {
          id: this.accountForm.id, 
          account: {
            ...this.accountForm,
            strict: this.accountForm.strict ? 1 : 0,
            owner_identification_type: this.checkIdentificationType(
              this.accountForm.owner_identification_type
            ),
            type: this.checkType(this.accountForm.type),
          },
          close: this.onClose
        })
      } else {
        this[CREATE_ACCOUNT]({
          account: {
            ...this.accountForm,
            strict: this.accountForm.strict ? 1 : 0,
            owner_identification_type: this.checkIdentificationType(
              this.accountForm.owner_identification_type
            ),
            type: this.checkType(this.accountForm.type),
          },
          close: this.onClose
        });
      }
    },
    checkType(type) {
      switch (type) {
        case "VES":
          return 0;
        default:
          return 1;
      }
    },
    checkIdentificationType(type) {
      switch (type) {
        case "V": 
          return 1
        case "J":
          return 2;
        case "R":
          return 3;
        default:
          return 1;
      }
    },
    setStrict() {
      this.accountForm.strict = !this.accountForm.strict;
    },
    setValue(account) {
      this.accountForm = { ...account };
    },
  },
  watch: {
    dialog(value) {
      this.dialogModel = value;
    },
    dialogModel(value) {
      this.$emit("update:dialog", value);
    },
  },
};
</script>

<style>
</style>
